export const SOLO_TERMS = {
  onboarding: {
    title: 'Get Expert Credit, Give Expert Credit',
    description: 'As a valued WeAdmit client, you’re eligible to participate in our Friend Referral program. Anytime a friend you referred signs up, you’ll earn an Expert Credit and your friend will too!',
    footer: 'To start earning Expert Credits, accept the following Terms of Participation.'
  },
  process: [
    'Invite your friend to sign up for WeAdmit.',
    'Once your friend subscribes to WeAdmit, they’ll receive a bonus Expert Credit in their account.',
    'You will receive an Expert Credit when your friend signs up, which you can redeem for an essay revision.'
  ],
  sync: {
    title: 'Share a free essay review with your friends.',
    description: 'Thank you for trusting WeAdmit and spreading the word about us! We truly appreciate your effort to bring your friends into our community. Anytime a friend you referred signs up, you’ll earn an Expert Credit!'
  },
  navCTA: 'Get an Expert Credit for each new client',
}

export const DEFAULT = {
  onboarding: {
    title: 'Get $250, Give $250!',
    description: 'As a valued WeAdmit client, you\'re eligible to participate in our Friend Referral Program. Anytime a friend you referred signs up, you’ll earn an Amazon e-gift card and your friend will receive a 10% discount on all of our services!',
    footer: 'To start earning money, accept the following Terms of Participation.'
  },
  process: [
    'Invite your friend to book a free, 30-minute counseling session.',
    'Once your friend completes their counseling session, they\'ll get a registration link along with a unique coupon code for a 10% discount on any program of their choice.',
    'You will receive an Amazon e-gift card within 45 business days of your friend’s signup. You’ll earn a $250 e-gift card if your friend signs up for any of our private college admissions counseling programs, $50 for group program registrations.'
  ],
  sync: {
    title: 'Share a 10% discount with your friends.',
    description: 'Thank you for trusting WeAdmit and spreading the word about us! We truly appreciate your effort to bring your friends into our community. Anytime a friend you referred signs up, you’ll earn an Amazon e-gift card!'
  },
  navCTA: 'Get $250 for each new client'
}